<template>
    <div>
        <div class="main-content f-left">
            <Form class="fullMob" @submit="submitQuestion()" style="min-height: 500px; justify-content: center; align-items: center; max-width: 65%; margin: 0 auto;" v-if="form_data.elements && form_data.elements.length">
                <div class="content-holder">
                    <div class="row-sec">
                        <div class="form-holder wow fadeInLeft">
                            <ul class="clearfix onclickList">
                                <h4 class="ltWer">Trullio form</h4>
                                <template v-for="item in form_data.elements" :key="item.id">
                                    <li class="" v-if="checkCondition(item.condition) || ['Mobile number','Telephone Number'].includes(item.name)">
                                        <div class="ltWer position-relative">
                                            <label for="">{{item.name}}<span class="red">*</span></label>
                                            <Field class="form-control" as="select" :name="item.name" v-model="form[item.id]" rules="required" v-if="item.type.includes('select')" @change="countryChange">
                                                <option value="" disabled>Select</option>
                                                <option v-for="country,iso in static_vars.trullioCountries" :key="iso" :value="iso">{{country}}</option>
                                            </Field>
                                            <Field class="form-control" :name="item.name" type="text" v-model="form[item.id]" maxlength="25" v-else-if="['First name','Last name'].includes(item.name) && form[countryId] == 'CN'" rules="required|isChinees"/>
                                            <Field class="form-control" :name="item.name" type="text" v-model="form[item.id]" maxlength="25" v-else-if="['Nationality ID number'].includes(item.name) && form[countryId] == 'CN'" rules="required|length:18"/>
                                            <Field class="form-control" :name="item.name" type="text" v-model="form[item.id]" maxlength="25" v-else-if="['First name','Last name'].includes(item.name) && form[countryId] == 'TH'" rules="required|isThai"/>
                                            <Field class="form-control" :name="item.name" type="text" v-model="form[item.id]" maxlength="25" rules="required|max:25" v-else-if="item.type.includes('text')"/>
                                            <Field class="form-control" :name="item.name" type="date" v-model="form[item.id]" :max="dobDate" rules="required" v-else-if="item.type.includes('date')" />
                                            <Field v-slot="{ field }" :name="item.name" rules="required" v-model="form[item.id].number" v-else-if="item.type.includes('phone_number')">
                                                <vue-tel-input v-bind="field" v-model="form[item.id].number" @change="onInput" @country-changed="GetCode" :onlyCountries="onlyCountries" :defaultCountry="defaultCountry" ref="phone"></vue-tel-input>
                                            </Field>
                                            <ErrorMessage :name="item.name" />
                                        </div>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="btn-holder t-center"><button type="submit" class="btn btn-yellow popup-link-holder">Submit</button></div>
            </Form>
            <!-- <div v-else-if="store.user.profile.trulio_applicantId">
                <Form @submit="submitFile()" id="image_upload">
                    <input type="hidden" name="context" value="front" />
                    <div class="mb-3">
                        <label for="formFile" class="form-label">Upload residence proof Front image</label>
                        <Field class="form-control" type="file" name="body" rules="required" />
                    </div>
                    <ErrorMessage name="body" />
                    <div class="btn-holder t-center"><button type="submit" class="btn btn-yellow popup-link-holder">Submit</button></div>
                </Form>
            </div> -->
        </div>
    </div>
</template>
<script>
    import { Form, Field, ErrorMessage, defineRule } from "vee-validate";
    defineRule('isChinees', (value) => {
        if (value && value.match(/[\u4E00-\u9FFF\u3400-\u4DFF\uF900-\uFAFF]+/g)) {
            return true;
        }
        return 'Only chinese langauge allow in this field';
    });
    defineRule('isThai', (value) => {
        if (value && value.match(/^[\u0E00-\u0E7F.-]{1,}(\s[\u0E00-\u0E7F.-]{1,}){0,2}?$/gm)) {
            return true;
        }
        return 'Only thai langauge allow in this field';
    });
    import { useMainStore } from "@/store";
    import moment from "moment";
    // import $ from "jquery";
    export default {
        setup() {
            return { store: useMainStore() };
        },
        data() {
            return {
                x_hf_session: "",
                form_data: {},
                form: {},
                dobDate: moment().subtract(18, "years").format("YYYY-MM-DD"),
                defaultCountry:'',
                // profile_data: {},
                countryId : '',
            };
        },
        components: { Form, Field, ErrorMessage },
        /*watch: {
            "store.user"(v) {
                if (v.profile.trulio_applicantId) {
                    this.profileDetail(v.profile.trulio_applicantId);
                }
            },
        },*/
        computed:{
            onlyCountries(){
                return Object.keys(this.static_vars.trullioCountries)
            },
            /*defaultCountry(){
                return this.store.user.country.toString();
            }*/
        },
        methods: {
            changeVal(e,id){
                console.log(e.target.value,id);
                // if (id == "First_nameCN" && e.target.value.match(/[\u4E00-\u9FFF\u3400-\u4DFF\uF900-\uFAFF]+/g)) {
                if (id == "First_nameCN" && e.target.value.match(/^[\u0E00-\u0E7F.-]{1,}(\s[\u0E00-\u0E7F.-]{1,}){0,2}?$/gm)) {
                    alert('Chinese character sets');
                }
            },
            countryChange(e) {
                this.defaultCountry = e.target.value;
                this.$refs.phone[0].choose(e.target.value);
                // this.setVariable();
                // this.setVariable(this.defaultCountry);
            },
            onInput(e) {
                // return;
                console.log('onInput ================>',e,e.target.value);
            },
            GetCode(e) {
                this.form_data.elements.forEach((v) => {
                    if (v.type == "phone_number") {
                        this.form[v.id].area = `+${e.dialCode}`;
                        this.form[v.id].country = e.iso2;
                    }
                });
            },
            submitFile() {
                const form = document.getElementById("image_upload");
                const formData = new FormData(form);
                this.store.trullioUploadDocument(formData, true)
                .then((res) => {
                    console.log("res===========>", res);
                })
                .catch((e) => {
                    console.log("error=========>", e);
                });
            },
            submitQuestion() {
                let form = {
                    /*x_hf_session : this.x_hf_session*/
                };
                /*for (const key in this.form) {
                    if (this.form[key]) {
                        form[key] = this.form[key];
                    }
                }*/
                this.form_data.elements.forEach((item) => {
                    if(this.checkCondition(item.condition)){
                        form[item.id] = this.form[item.id]
                    }
                });
                this.store.submitTrullioForm(form, true).then((res) => {
                    console.log("res===========>", res);
                    if (res.type === "pending") {
                        this.submitQuestion();
                    }else if (res.type === "end" && res.id) {
                        this.profileDetail(res.id);
                        this.store.refreshUserData();
                    }
                })
                .catch((e) => {
                    console.log("error=========>", e);
                });
            },
            checkCondition(condition) {
                if (condition?.rules.length) {
                    return condition.rules.map((v) => v.comparable.value).includes(this.form[condition.rules[0].fieldId]);
                } else {
                    return true;
                }
            },
            setVariable(country){
                this.form_data.elements.forEach((v) => {
                    if (v.type == "country_select" && !this.form[v.id]) {
                        this.countryId = v.id;
                        this.form[v.id] = country;
                    }else if (v.type == "phone_number" && !this.form[v.id]) {
                        this.form[v.id] = {
                            area: "",
                            number: this.store.user.mobile_no,
                            country: country
                        };
                        this.defaultCountry = country
                    }else if(["country_select","phone_number"].includes(v.type)){
                        this.form[v.id] = "";
                    }
                });
            },
            trulioFormApi() {
                this.store.getTrullioForm({}, true).then((res) => {
                    this.x_hf_session = res.x_hf_session;
                    this.form_data = JSON.parse(res.body);
                    this.setVariable(this.store.user.country.toString())
                })
                .catch(() => {
                    // console.log("error=========>", e);
                });
            },
            profileDetail(transactionRecordId) {
                this.store.getTrullioProfile({ transactionRecordId }, true)
                .then((res) => {
                    console.log("res ==================>",res);
                    // console.log("profileDetail ==================>",JSON.parse(res.body));
                    // this.profile_data = JSON.parse(res.body);
                })
                .catch((e) => {
                    console.log("error=========>", e);
                });
            },
        },
        mounted() {
                console.log('--------------------------------->')
            /*if (this.store.user?.profile.trulio_transaction_record_id) {
                this.profileDetail(this.store.user.profile.trulio_transaction_record_id);
            }else{*/
            if(!this.store.user.profile.poa_status){
                this.trulioFormApi()
            }
            // }
        },
    };
</script>
